import { Component, OnInit, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {
  faAngleDown,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faCalendar,
  faChild,
  faClock,
  faClose,
  faEnvelope,
  faEnvelopeOpen,
  faFaceSmile,
  faL,
  faLocationDot,
  faLongArrowRight,
  faMinus,
  faPersonWalkingLuggage,
  faPlane,
  faPlaneArrival,
  faPlaneDeparture,
  faPlus,
  faRightLeft,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import { merge, Observable, of } from 'rxjs';
import { ActiveModifySearch, BookingBasicProperties, ChildAgeProps, FlightSearchAirlineCodes, FlightSearchAirports, FlightSearchBaseData, FlightSearchDestinationProperties, FlightSearchHistory, FlightSearchProperties, FlightSearchRights, InfantAgeProps, OtherFlightDetailsNames } from '../Models/FlightSearchProperties';
import { FaretypeFilters, FilterFlightResultBinding, FlightSchedulesNew, FlightSearchNewResponseProperties, StopFlightFilters, flightsectorIndex, MulticityResponseFlightsNew, TimeListFilter, FilterByAirlineProperties, AirSegmentsDetailsNew, BySectorBrands } from '../Models/flight-results-response-properties';
import { FlightSearchService } from '../Services/FlightSearch.service';
import { MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { BsDatepickerConfig, BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { FlightResultAdditionalProcess } from '../flightResultsNew/flight-result-filters-process';
import { GetFlightResultsService } from '../Services/get-flight-results.service';
import { EmailItineraryProperties } from '../Models/ERPProperties';
import { AgencyMasterProperties } from '../Models/AgencyMasterProperties';
import { EmailItineraryService } from '../Services/emailItinerary.service';
import { ChangeRBDParamsGalileo, SelectRBD } from '../Models/FlightSearchResponseProperties';
import { GroupTicketService } from '../Services/groupTicket.service';
import { GroupTicketProperties, GroupTicketSearchParameters } from '../Models/GroupTicketProperties';
import { BookingTimerService } from '../Services/booking-timer.service';


@Component({
  selector: 'app-group-ticket-for-user-new',
  templateUrl: './group-ticket-for-user-new.component.html',
  styleUrls: ['./group-ticket-for-user-new.component.css'],
  providers: [BsDatepickerConfig, BsDaterangepickerConfig]
})
export class GroupTicketForUserNewComponent implements OnInit {
  flightresultadditionalProcessts = new FlightResultAdditionalProcess();

  faplane = faPlane;
  faArrowRightToCity = faLongArrowRight;
  faLocationDot = faLocationDot;
  faPlaneDeparture = faPlaneDeparture;
  faPlaneArrival = faPlaneArrival;
  faMinus = faMinus;
  faplus = faPlus;
  faRightLeft = faRightLeft;
  faPlus = faPlus;
  Close = faClose;
  PersonIcon = faUser;
  faChild = faChild;
  FaceSmile = faFaceSmile;
  faArrowUp = faArrowUp;
  faEnvelope = faEnvelope;
  faEnvelopeOpen = faEnvelopeOpen;
  faArrowDown = faArrowDown;
  faAngleDown = faAngleDown;
  faCalendar = faCalendar;
  PersonWalking = faPersonWalkingLuggage;
  faArrowRight = faArrowRight;
  faArrowLeft = faArrowLeft;
  faClock = faClock;

  screenHeight: number;
  screenWidth: number;
  loaderSending: boolean = false;
  dateCalenderShow: number = 3;
  rangeDates: Date[] | undefined;
  childList: Number[] = [];
  infantList: Number[] = [];
  filteredAirportsOW: string[] = [];
  airportList: FlightSearchAirports[] = [];

  //adultDropdowndiv: boolean = false;
  //dropdownadult = false;
  //dropdowneconomy = false;
  //dropdownfaretype = false;
  //childAge: boolean = false;
  //InfantAge: boolean = false;
  //childAgeItemR: number = 0;
  //childAgeValueR: number;
  //childAgeListOf: ChildAgeProps[] = [];
  //infantAgeListOf: InfantAgeProps[] = [];
  //childAgeItem: number = 0;
  //priceOfBrand: number = 0;
  //childAgeValue: number;
  //infantAgeValue: string;
  //checkpanelcollapsed: boolean = false;
  //Adulttravlers: boolean = true;
  //AllTravelers: boolean = false;
  // childAgeListOfR: ChildAgeProps[] = [];
  // infantAgeListOfR: InfantAgeProps[] = [];


  finalcountofpassengers: number = 1;
  infantAgeValueR: string;
  IMPORTRights: boolean = false;
  currentIndex: number = 0;
  modifymultishow: boolean = false;
  modifyorignalshow: boolean = true;
  minDate: Date;
  maxDate: Date;
  haveRights: boolean = false;
  allBaseData$ = new FlightSearchBaseData();
  airlineList$: Observable<FlightSearchAirlineCodes[]>;
  childAgeObj = new ChildAgeProps();
  dataSource: any;
  infantAgeObj = new InfantAgeProps();
  airLineData: FlightSearchAirlineCodes[] = [];
  searchObj = new FlightSearchProperties();
  modifysearchObj = new FlightSearchProperties();
  onewaymodifysearchObj = new FlightSearchProperties();
  roundmodifysearchObj = new FlightSearchProperties();
  multicitymodifysearchObj = new FlightSearchProperties();
  sentToBacksearchObj = new FlightSearchProperties();
  AgencyData = new AgencyMasterProperties();
  ingredient: boolean = false;
  dataFormSubmitoneway: boolean = false;
  flightDetailsopen: boolean[] = [false];
  brandDetailsopen: boolean[] = [false];
  farerulesopen: boolean[] = [false];
  emailpopupopen: boolean = false;
  sliderAirlineShow: boolean = true
  emailpopupValidateCheck: boolean = false;
  emailpopupFlightIndex: number = 0;
  baggagedetailsopen: boolean[] = [false];
  passengerDetailsOpen: boolean[] = [false];
  changebookingdetailsopen: boolean[] = [false];
  selectedDiv: number | null = null;
  emailObj = new EmailItineraryProperties();
  flighResultObj = new FlightSearchNewResponseProperties();
  activesearch: number = 0;
  initialsearch: number = 0;
  flightsBindList: FlightSchedulesNew[] = [];
  displayedFlights: FlightSchedulesNew[] = [];
  batchSize: number = 100;
  startIndex: number = 0;
  popoverArray: boolean[] = [];
  filtersBinding = new FilterFlightResultBinding();
  currencyForShow: string = "";
  //oneWayResults: boolean = false;
  //roundTripResults: boolean = false;
  //multicityResults: boolean = false;

  //mobile declareation start here 
  mobilepopupmodifysearch: boolean = false;
  grossPrice: string;
  minValueSliderFilter: number = 0;
  maxValueSliderFilter: number = 0;
  tooltip: any;
  flightsectorIndexlist: flightsectorIndex[] = [];
  flightrequestCounter: number;
  flightresponseCounter: number;
  flightshortCountSkelton: number[] = [];
  flightsloading: boolean = false;
  flightsBeforeLoad: boolean;
  progressValue: number;
  totalDirectFlights: number = 0;
  totalOneStopFlights: number = 0;
  totalTwoPlusStopFlights: number = 0;
  totalRefundableFlights: number = 0;
  totalNonRefundableFlights: number = 0;

  //group ticket
  flightSearchRightsObj = new FlightSearchRights();
  noflightavailable: boolean = false;
  previousmarkup: number = 0;
  groupTicketSearch = new GroupTicketSearchParameters();
  flightLocationInfo: FlightSearchDestinationProperties[] = [];
  filterTabs: FlightSchedulesNew[] = [];
  uniqueGroups: FlightSchedulesNew[] = [];
  totalGroupTickets: number = 0;
  remainingGroupTickets: number = 0;
  adultValidationError: boolean = false;
  childValidationError: boolean = false;
  infantValidationError: boolean = false;
  infantError: boolean = false;
  totalExceedsError: boolean = false;

  constructor(private bookingTimerService: BookingTimerService, private emailService: EmailItineraryService, private router: Router, private flightService: FlightSearchService, private getFlightResultService: GetFlightResultsService, private messageService: MessageService, private groupTicketService: GroupTicketService) {
  }
  @ViewChild('slider', { static: false }) slider: ElementRef<HTMLElement>;
  @ViewChild('slide', { static: false }) slide: ElementRef<HTMLElement>;
  ngOnInit() {


    try {
      
      this.currencyForShow = localStorage.getItem("AgencyCurrency");
      this.initialsearch = this.searchObj.journeyType;
      this.finalcountofpassengers = this.searchObj.adult + this.searchObj.child + this.searchObj.infant;
      this.filtersBinding.airlinesList = [];
      this.filtersBinding.fareType = new FaretypeFilters();
      this.filtersBinding.timeList = new TimeListFilter();
      this.filtersBinding.stopsDetails = new StopFlightFilters();
      this.filtersBinding.stopsDetailsReturn = new StopFlightFilters();
      this.filtersBinding.stopsDetails = new StopFlightFilters();
      this.tooltip = {
        enabled: true,
        showMode: 'always',
        position: 'top',
      };
    }
    catch (e) {

    }

    this.GetSearchBaseData();
    this.GetAgencyMasterForPrint();
    this.GetGroupTicketResult();

  }



  GetSearchBaseData() {
    try {
      this.flightService.CheckFlightSearchScreenRights(localStorage.getItem("UserId"), localStorage.getItem("AgencyId")).subscribe((data1) => {
        this.haveRights = data1;
        this.flightService.GetFlightBaseData().subscribe((data) => {
          this.allBaseData$ = data;
          /* this.originalAirlines = this.allBaseData$.airlines;*/
          this.airlineList$ = of(this.allBaseData$.airlines);


          this.airLineData = this.allBaseData$.airlines;
          this.airportList = this.allBaseData$.airports;


          this.dataSource = new DataSource({
            store: new ArrayStore({
              data: this.airportList,
              key: "airportName"
            }),
            group: "cityCountry",

          });
          this.flightService.CheckImportRights(localStorage.getItem("UserId"), localStorage.getItem("AgencyId")).subscribe((data2) => {
            this.IMPORTRights = data2;
          })
          this.dataSource.load();

          // this.tbOnewayFromAuto.instance.focus();
          //}
        })
      })
    }
    catch (e) {

    }
  }

  //filterAirportsOW(event: any) {
  //  let filteredOW: string[] = [];
  //  let query = event.query.toLowerCase();
  //  for (let i = 0; i < this.airportList.length; i++) {
  //    let airportOW = this.airportList[i];
  //    if (airportOW.iatA_CODE.toLowerCase().startsWith(query) || airportOW.city.toLowerCase().startsWith(query)) {
  //      if (airportOW.iatA_CODE.toLowerCase() === query) {
  //        filteredOW[0] = airportOW.airportName;
  //      }
  //      filteredOW.push(airportOW.airportName);
  //    }
  //  }
  //  filteredOW = [...new Set(filteredOW)];
  //  this.filteredAirportsOW = filteredOW;
  //}

  
  nextSlide() {
    const totalSlides = document.querySelectorAll('.slide').length;
    if (this.currentIndex < totalSlides - 5) {
      this.currentIndex++;
      this.updateSlider();
    }
  }
  prevSlide() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateSlider();
    }
  }
  updateSlider() {
    const sliderElement = this.slider.nativeElement;
    const slideWidth = this.slide.nativeElement.offsetWidth;
    sliderElement.style.transform = `translateX(${-this.currentIndex * slideWidth}px)`;
  }


  GetAgencyMasterForPrint() {
    this.flightService.GetAgencyForPrint(localStorage.getItem("AgencyId")).subscribe((data) => {
      this.AgencyData = data;
    });
  }
  openotherDetails(type: number, index: number) {
    if (OtherFlightDetailsNames.Baggage == type) {
      this.baggagedetailsopen[index] = true;
    }
    else if (OtherFlightDetailsNames.FareRules == type) {
      this.farerulesopen[index] = true;
    }
    else if (OtherFlightDetailsNames.Print == type) {

      this.flightLocationInfo = [];
      let flight = new FlightSearchDestinationProperties();

      flight.departureDate = this.displayedFlights[index].departureFlight.departure.date;
      flight.fromCity = this.displayedFlights[index].departureFlight.departure.city;
      flight.fromAirport = this.displayedFlights[index].departureFlight.departure.airport;

      flight.toCity = this.displayedFlights[index].departureFlight.arrival.city;
      flight.toAirport = this.displayedFlights[index].departureFlight.arrival.airport;

      this.flightLocationInfo.push(flight);

      if (this.displayedFlights[index].returnFlight != null) {

        let flight = new FlightSearchDestinationProperties();

        flight.departureDate = this.displayedFlights[index].returnFlight.departure.date;
        flight.fromCity = this.displayedFlights[index].returnFlight.departure.city;
        flight.fromAirport = this.displayedFlights[index].returnFlight.departure.airport;
        flight.toCity = this.displayedFlights[index].returnFlight.arrival.city;
        flight.toAirport = this.displayedFlights[index].returnFlight.arrival.airport;

        this.flightLocationInfo.push(flight);
      }

      this.modifysearchObj.flightLocationInfo = this.flightLocationInfo;

      if (this.displayedFlights[index].returnFlight == null) {

        this.flightresultadditionalProcessts.printClickOneWay(this.displayedFlights[index], this.AgencyData, this.emailObj, this.emailObj.includeAllResults, this.modifysearchObj,
          this.flightsBindList, this.initialsearch);

      } else {
        this.flightresultadditionalProcessts.ReturnPrintClick(this.displayedFlights[index], this.AgencyData, this.emailObj, this.emailObj.includeAllResults, this.modifysearchObj,
          this.flightsBindList, this.initialsearch);
      }
    }
    else if (OtherFlightDetailsNames.Email == type) {
      this.emailpopupopen = true;
      this.emailpopupFlightIndex = index;

    }
    else if (OtherFlightDetailsNames.FlightDetails == type) {

      this.flightLocationInfo = [];

      let flight = new FlightSearchDestinationProperties();

      flight.departureDate = this.displayedFlights[index].departureFlight.departure.date;
      flight.fromCity = this.displayedFlights[index].departureFlight.departure.city;
      flight.fromAirport = this.displayedFlights[index].departureFlight.departure.airport;

      flight.toCity = this.displayedFlights[index].departureFlight.arrival.city;
      flight.toAirport = this.displayedFlights[index].departureFlight.arrival.airport;

      this.flightLocationInfo.push(flight);

      if (this.displayedFlights[index].returnFlight != null) {

        let flight = new FlightSearchDestinationProperties();

        flight.departureDate = this.displayedFlights[index].returnFlight.departure.date;
        flight.fromCity = this.displayedFlights[index].returnFlight.departure.city;
        flight.fromAirport = this.displayedFlights[index].returnFlight.departure.airport;
        flight.toCity = this.displayedFlights[index].returnFlight.arrival.city;
        flight.toAirport = this.displayedFlights[index].returnFlight.arrival.airport;

        this.flightLocationInfo.push(flight);
      }

      this.flightDetailsopen[index] = true;
    }
    else if (OtherFlightDetailsNames.PassengerDetails == type) {
      this.sentToBacksearchObj = new FlightSearchProperties();
      this.sentToBacksearchObj.groupId = this.displayedFlights[index].departureFlight.groupTicketId;
      this.passengerDetailsOpen[index] = true;
    }
  }

  emailClick(form: any) {
    this.emailpopupValidateCheck = true;
    if (form.invalid) {
      return;
    }
    if (this.displayedFlights[this.emailpopupFlightIndex].returnFlight === null) {

      this.initialsearch = 1

    } else {

      this.initialsearch = 2
    }
    if (this.initialsearch == 1 || this.initialsearch == 2) {
      //this.loaderSending = true;
      let emailObj: EmailItineraryProperties = this.flightresultadditionalProcessts.sendEmails(this.displayedFlights[this.emailpopupFlightIndex], this.AgencyData, this.emailObj, this.emailObj.includeAllResults, this.modifysearchObj,
        this.flightsBindList, this.initialsearch);
      if (emailObj.body == null) {
        this.loaderSending = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error While Adding Data' });
      }
      else {
        this.emailService.emailItinerary(this.emailObj).subscribe((data) => {
          this.loaderSending = false;
          if (data == true) {
            this.emailpopupopen = false;
            this.messageService.add({ severity: 'success', summary: 'Sent', detail: 'Email Successfully Sent' });


          }
          else {
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Email Not Sent' });
          }

        });
      }
    }

  }

  flightLoaderClose() {

    if (this.flightrequestCounter == this.flightresponseCounter) {

      if (this.flightsBindList.length > 0) {

        this.flightsloading = false;
        this.flightshortCountSkelton = [];
        this.noflightavailable = false;

      }
      else {
        this.flightsloading = false;
        this.flightshortCountSkelton = [];
        this.noflightavailable = true;
        this.sliderAirlineShow = false;
      }
    }

  }


  toggleWithAnimationOptions(index: number) {
    this.popoverArray[index] = !this.popoverArray[index];
    let totalPrice = 0;
    for (let i = 0; i < this.displayedFlights[index].passengerFares.length; i++) {
      totalPrice += Number(this.displayedFlights[index].passengerFares[i].agencyTotalPrice.substring(3));
    }
    this.grossPrice = this.displayedFlights[index].passengerFares[0].agencyTotalPrice.substring(0, 3) + " " + totalPrice.toFixed(2);
  }

  airlineSmallCardfilter(selectedGroup: string) {

    if (selectedGroup == "All") {

      this.displayedFlights = [];
      this.flightsBindList = this.filterTabs;
      this.batchSize = 100;
      this.startIndex = 0;
    } else {


      this.displayedFlights = [];

      let flightnewresult = this.filterTabs;
      flightnewresult = flightnewresult.filter(group =>
        group.groupTitle == selectedGroup);

      this.flightsBindList = flightnewresult;
      this.batchSize = 50;
      this.startIndex = 0;
    }

    this.loadNextFlights();
  }


  loadNextFlights() {
    const endIndex = Math.min(this.startIndex + this.batchSize, this.flightsBindList.length);
    this.displayedFlights = this.displayedFlights.concat(this.flightsBindList.slice(this.startIndex, endIndex));

    this.startIndex = endIndex;
  }


  GetGroupTicketResult = (): void => {
    this.flightService.GetAgencyAndUserGroupTicketRigts(localStorage.getItem("UserId"), localStorage.getItem("AgencyId")).subscribe((data) => {
      this.flightSearchRightsObj = data;
      if (this.flightSearchRightsObj.agencyGroupTicketSearch == true && this.flightSearchRightsObj.userGroupTicketSearch == true) {
        this.searchObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
        this.getFlightResultService.GetGroupFlightResultNew(this.searchObj).subscribe((data) => {

          if (data.flights != null) {
            if (data.flights.length > 0) {

              this.flightsBindList = data.flights;

              this.displayedFlights = [];

              this.startIndex = 0;
              this.batchSize = 50;

              this.loadNextFlights();

              //==== for creating ticket groups ======

              this.filterTabs = data.flights;

              this.uniqueGroups = [];
              let seenGroupTitles: Set<string> = new Set();
              let groupedSums: { [key: string]: { totalNumberTicket: number, remainingTickets: number } } = {};


              for (let i = 0; i < this.filterTabs.length; i++) {

                let group = this.filterTabs[i];
                if (!seenGroupTitles.has(group.groupTitle)) {

                  this.uniqueGroups.push(group);

                  let groupWiseTotalTickets = this.filterTabs
                    .filter(f => f.groupTitle === group.groupTitle)
                    .reduce((sum, f) => sum + f.totalNumberTicket, 0);

                  let groupWiseRemainingTickets = this.filterTabs
                    .filter(f => f.groupTitle === group.groupTitle)
                    .reduce((sum, f) => sum + f.remainingTickets, 0);

                  groupedSums[group.groupTitle] = {
                    totalNumberTicket: groupWiseTotalTickets,
                    remainingTickets: groupWiseRemainingTickets
                  };

                  seenGroupTitles.add(group.groupTitle);
                }
              }


              this.uniqueGroups.forEach(group => {
                let sums = groupedSums[group.groupTitle];
                if (sums) {
                  group.totalNumberTicket = sums.totalNumberTicket;
                  group.remainingTickets = sums.remainingTickets;
                }
              });

              this.totalGroupTickets = this.uniqueGroups.reduce((sum, flight) => sum + flight.totalNumberTicket, 0);
              this.remainingGroupTickets = this.uniqueGroups.reduce((sum, flight) => sum + flight.remainingTickets, 0);

            }
            else {
              this.sliderAirlineShow = false;
              this.noflightavailable = true;
            }
          }


          for (let j = 0; j < this.flightsBindList.length; j++) {
            this.popoverArray.push(false);
          }

          this.flightLoaderClose();

        });

      }
      else {
        this.sliderAirlineShow = false;
        this.noflightavailable = true;
      }
    });
  }

  addPassengerDetails(index: number) {

    this.flightLocationInfo = [];
    let flight = new FlightSearchDestinationProperties();

    flight.departureDate = this.displayedFlights[index].departureFlight.departure.date;
    flight.fromCity = this.displayedFlights[index].departureFlight.departure.city;
    flight.fromAirport = this.displayedFlights[index].departureFlight.departure.airport;
    flight.toCity = this.displayedFlights[index].departureFlight.arrival.city;
    flight.toAirport = this.displayedFlights[index].departureFlight.arrival.airport;

    this.flightLocationInfo.push(flight);

    if (this.displayedFlights[index].returnFlight != null) {
      let flight = new FlightSearchDestinationProperties();

      flight.departureDate = this.displayedFlights[index].returnFlight.departure.date;
      flight.fromCity = this.displayedFlights[index].returnFlight.departure.city;
      flight.fromAirport = this.displayedFlights[index].returnFlight.departure.airport;
      flight.toCity = this.displayedFlights[index].returnFlight.arrival.city;
      flight.toAirport = this.displayedFlights[index].returnFlight.arrival.airport;

      this.flightLocationInfo.push(flight);
    }

    this.sentToBacksearchObj.groupId = this.displayedFlights[index].departureFlight.groupTicketId;
    this.sentToBacksearchObj.flightLocationInfo = this.flightLocationInfo;

    // this.validateInfants(this.sentToBacksearchObj.infant, this.sentToBacksearchObj.adult);
    this.validatePassengers(this.sentToBacksearchObj.adult, this.sentToBacksearchObj.child, this.sentToBacksearchObj.infant, index);


    if (!this.infantError && !this.adultValidationError  && !this.totalExceedsError) {
      this.sentToBacksearchObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
      this.getFlightResultService.GetGroupFlightResultNew(this.sentToBacksearchObj).subscribe((data) => {

        if (data.flights != null) {
          if (data.flights.length > 0) {

            let requestObj = new BookingBasicProperties();
            requestObj.groupTicketId = this.sentToBacksearchObj.groupId;
            requestObj.extraProfit = this.filtersBinding.applyMarkup;
            requestObj.fromAirport = data.flights[0].fromAirport;
            requestObj.toAirport = data.flights[0].toAirport;
            requestObj.airportsList = this.airportList;
            requestObj.bookingPCC = data.flights[0].departureFlight.pcc;
            requestObj.airSegment = data.flights[0].airSegmentsNew;
            requestObj.flightProp = this.sentToBacksearchObj;
            requestObj.stopcount = data.flights[0].departureFlight.stopCount;
            requestObj.supplierCode = data.flights[0].departureFlight.supplier;
            requestObj.passengerFares = data.flights[0].passengerFares;
            requestObj.nonRefundable = data.flights[0].departureFlight.nonRefundable;
            requestObj.supplierPricingSolution = data.flights[0].supplierPricingSolution;
            requestObj.transactionIdentifierJ = data.flights[0].transactionIdentifier;
            requestObj.flightscheduleNew = data.flights[0];
            this.bookingTimerService.setTime(30);

            sessionStorage.setItem('bkdata', JSON.stringify(requestObj));
            this.router.navigateByUrl('/passengerInfo');

          }
        }
      });
    }
  }


  calculateSum2(agencyTaxAmount: string | undefined, serviceCharges: string | undefined): number {
    if (!agencyTaxAmount || !serviceCharges) {
      return 0;
    }
    const taxAmount = parseFloat(agencyTaxAmount.substring(3));
    const charges = parseFloat(serviceCharges.substring(3));
    return taxAmount + charges;
  }


  validateAdults(adults: number) {

    console.log("validateAdults");

    if (adults < 0) {
      this.adultValidationError = true;
      const adultErrorElement = document.getElementById("adultErrorMsg");
      adultErrorElement.style.display = "block";
      adultErrorElement.innerHTML = "Please enter valid number of adult passenger(s)!";
      setTimeout(() => {
        adultErrorElement.style.display = "none";
        adultErrorElement.innerHTML = "";
        this.adultValidationError = false;
      }, 3000);
    }
  }


  validateChildren(child: number) {

    console.log("validateChildren");

    if (child < 0) {
      this.childValidationError = true;
      const childErrorElement = document.getElementById("childErrorMsg");
      childErrorElement.style.display = "block";
      childErrorElement.innerHTML = "Please enter valid number of child passenger(s)!";
      setTimeout(() => {
        childErrorElement.style.display = "none";
        childErrorElement.innerHTML = "";
        this.childValidationError = false;
      }, 3000);
    } 
  }


  validateInfants(infant: number) {

    console.log("validateInfants");

    if (infant < 0) {
      this.infantError = true;
      const infantErrorElement = document.getElementById("infantErrorMsg");
      infantErrorElement.style.display = "block";
      infantErrorElement.innerHTML = "Please enter valid number of infant passenger(s)!";
      setTimeout(() => {
        infantErrorElement.style.display = "none";
        infantErrorElement.innerHTML = "";
        this.infantError = false;
      }, 3000);
    } 
  }

  validatePassengers(adult: number, child: number, infant: number, index: number) {

    console.log("validatePassengers");

    if ((this.displayedFlights[index].isAdult == true) && (adult < 1)) {
      this.adultValidationError = true;
      const adultErrorElement = document.getElementById("adultErrorMsg");
      adultErrorElement.style.display = "block";
      adultErrorElement.innerHTML = "Number of adult passengers cannot be less than one!";
      setTimeout(() => {
        adultErrorElement.style.display = "none";
        adultErrorElement.innerHTML = "";
        this.adultValidationError = false;
      }, 3000);
    } 
      if (infant > adult) {
      this.infantValidationError = true;
      const infantErrorElement = document.getElementById("infantErrorMsg");
      infantErrorElement.style.display = "block";
      infantErrorElement.innerHTML = "Number of infants cannot exceed number of adult passengers!";
      setTimeout(() => {
        infantErrorElement.style.display = "none";
        infantErrorElement.innerHTML = "";
        this.infantValidationError = false;
      }, 3000);
    }

    const total = adult + child + infant;

    this.totalExceedsError = total > this.flightsBindList[index].remainingTickets;

    if (this.totalExceedsError) {
      const totalExceedErrorElement = document.getElementById("totalExceedErrorMsg");
      totalExceedErrorElement.style.display = "block";
      totalExceedErrorElement.innerHTML = "Number of passengers cannot exceed number of available seats!";
      setTimeout(() => {
        totalExceedErrorElement.style.display = "none";
        totalExceedErrorElement.innerHTML = "";
        this.totalExceedsError = false;
      }, 3000);
    }
  }
}
